import C from "../../../constants";

const clearComparisonTable = () => {
  return {
    type: C.CLEAR_COMPARISON_TABLE
  };
};

export default clearComparisonTable;
